import { LoginInput, useLoginMutation } from "generated/graphql";
import { useCallback } from "react";

export default function useLogin() {
  const [loginMutation, { loading, error, data }] = useLoginMutation({
    refetchQueries: ["me", "customMe"],
  });

  const login = useCallback(
    (values: LoginInput, force?: boolean) => {
      return loginMutation({
        variables: {
          input: values,
          force,
        },
      });
    },
    [loginMutation]
  );

  const loginResult = data?.login;
  const isUser = loginResult?.__typename === "User";
  const isConflict = loginResult?.__typename === "ActiveSessionConflict";
  const success = isUser;
  const user = isUser ? loginResult : null;
  const conflictMessage = isConflict ? loginResult.message : null;

  return [login, { data, loading, error, success, user, conflictMessage }] as const;
}
